<template>
  <div>
    <label :for="id" class="block text-sm font-medium">{{ label }}</label>
    <input
      type="text"
      v-model="input"
      :name="id"
      :id="id"
      :autocomplete="autocomplete"
      class="mt-1 focus:ring-samplyBlue focus:border-samplyBlue bg-gray-800 block w-full shadow-sm sm:text-sm border-gray-500 rounded-md"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    label: String,
    id: String,
    autocomplete: String,
    modelValue: {
      required: true,
      type: [String, Number]
    }
  },
  computed: {
    input: {
      get(): string | number {
        return this.modelValue;
      },
      set(value: string | number) {
        this.$emit("update:modelValue", value);
      }
    }
  }
});
</script>

<style></style>
